module.exports = __webpack_public_path__ + "img/table-list.2f0ff941.svg";